import { styled } from 'styled-system/jsx'

const BarRoot = styled('div', {
  base: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    backgroundColor: '#FFFFFF',
    borderRadius: 'lg',
    padding: '14px 16px',
    border: '1.5px solid',
    borderColor: '#E5E0F5',
    boxShadow: '0 12px 32px -16px rgba(128, 84, 255, 0.12)',
  },
})

const TopRow = styled('div', {
  base: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    flexWrap: 'wrap',
  },
})

const SearchWrapper = styled('div', {
  base: {
    flex: '1',
    minWidth: '220px',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    paddingX: '14px',
    paddingY: '10px',
    borderRadius: 'pill',
    backgroundColor: '#FAF7FF',
    border: '1.5px solid',
    borderColor: '#E5E0F5',
    _focusWithin: {
      borderColor: 'quickpass.primary',
      backgroundColor: '#FFFFFF',
    },
  },
})

const SearchIcon = styled('span', {
  base: {
    fontSize: '16px',
    color: 'quickpass.inkSoft',
    flexShrink: '0',
  },
})

const SearchInput = styled('input', {
  base: {
    flex: '1',
    minWidth: '0',
    fontFamily: 'body',
    fontSize: '15px',
    border: 'none',
    outline: 'none',
    backgroundColor: 'transparent',
    color: 'quickpass.ink',
    _placeholder: { color: '#B8B0CC', opacity: '1' },
  },
})

const ChipButton = styled('button', {
  base: {
    fontFamily: 'body',
    fontSize: '13px',
    fontWeight: '600',
    paddingX: '12px',
    paddingY: '7px',
    borderRadius: 'pill',
    border: '1.5px solid',
    borderColor: '#E5E0F5',
    backgroundColor: '#FFFFFF',
    color: 'quickpass.ink',
    cursor: 'pointer',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
    transition:
      'border-color {durations.fast} {easings.appleStandard}, background-color {durations.fast} {easings.appleStandard}',
    _hover: {
      borderColor: 'quickpass.primary',
    },
  },
  variants: {
    isActive: {
      true: {
        borderColor: 'quickpass.primary',
        backgroundColor: '#F1ECFF',
        color: 'quickpass.primary',
      },
    },
  },
})

const ResetButton = styled('button', {
  base: {
    fontFamily: 'body',
    fontSize: '13px',
    fontWeight: '600',
    color: 'quickpass.inkSoft',
    backgroundColor: 'transparent',
    border: 'none',
    cursor: 'pointer',
    paddingX: '10px',
    paddingY: '7px',
    borderRadius: 'pill',
    _hover: {
      color: 'quickpass.primary',
      backgroundColor: '#F1ECFF',
    },
  },
})

const ActiveCountChip = styled('span', {
  base: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: '20px',
    height: '20px',
    paddingX: '6px',
    borderRadius: 'pill',
    backgroundColor: 'quickpass.primary',
    color: '#FFFFFF',
    fontFamily: 'body',
    fontSize: '11px',
    fontWeight: '700',
  },
})

const ExpandedPanel = styled('div', {
  base: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
    gap: '14px',
    paddingTop: '12px',
    borderTop: '1px solid #F1ECFF',
  },
})

const PanelSection = styled('div', {
  base: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
})

const PanelLabel = styled('span', {
  base: {
    fontFamily: 'body',
    fontSize: '12px',
    fontWeight: '700',
    color: 'quickpass.inkSoft',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
  },
})

const ChipRow = styled('div', {
  base: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '6px',
  },
})

const PriceInputRow = styled('div', {
  base: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
})

const PriceInput = styled('input', {
  base: {
    width: '100%',
    minWidth: '0',
    fontFamily: 'body',
    fontSize: '14px',
    paddingX: '12px',
    paddingY: '8px',
    borderRadius: 'sm',
    border: '1.5px solid',
    borderColor: '#E5E0F5',
    backgroundColor: '#FFFFFF',
    color: 'quickpass.ink',
    outline: 'none',
    _focus: {
      borderColor: 'quickpass.primary',
    },
    _placeholder: { color: '#B8B0CC', opacity: '1' },
  },
})

const PriceSeparator = styled('span', {
  base: {
    fontFamily: 'body',
    fontSize: '13px',
    color: 'quickpass.inkSoft',
  },
})

const CityTagRow = styled('div', {
  base: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '6px',
    alignItems: 'center',
  },
})

const CityTag = styled('span', {
  base: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
    paddingX: '10px',
    paddingY: '4px',
    borderRadius: 'pill',
    backgroundColor: '#F1ECFF',
    color: 'quickpass.primary',
    fontFamily: 'body',
    fontSize: '12px',
    fontWeight: '600',
  },
})

const CityTagRemoveButton = styled('button', {
  base: {
    border: 'none',
    background: 'none',
    color: 'inherit',
    cursor: 'pointer',
    fontSize: '14px',
    lineHeight: '1',
    padding: '0',
    _hover: {
      opacity: '0.7',
    },
  },
})

const CityInput = styled('input', {
  base: {
    flex: '1',
    minWidth: '120px',
    fontFamily: 'body',
    fontSize: '14px',
    paddingX: '10px',
    paddingY: '6px',
    borderRadius: 'sm',
    border: '1.5px dashed',
    borderColor: '#E5E0F5',
    backgroundColor: '#FFFFFF',
    color: 'quickpass.ink',
    outline: 'none',
    _focus: { borderColor: 'quickpass.primary' },
    _placeholder: { color: '#B8B0CC', opacity: '1' },
  },
})

export {
  BarRoot,
  TopRow,
  SearchWrapper,
  SearchIcon,
  SearchInput,
  ChipButton,
  ResetButton,
  ActiveCountChip,
  ExpandedPanel,
  PanelSection,
  PanelLabel,
  ChipRow,
  PriceInputRow,
  PriceInput,
  PriceSeparator,
  CityTagRow,
  CityTag,
  CityTagRemoveButton,
  CityInput,
}
